export enum FEATURE_RESTRICTION {
  KYC_RESTRICTION = 'kyc_restriction',
  WALLET_ADDRESS_RESTRICTION = 'wallet_address_restriction',
  REGION_RESTRICTION = 'region_restriction',
  GLOBAL_RESTRICTION = 'global_restriction',
  WHITELABEL_RESTRICTION = 'whitelabel_restriction',
  ROLE_RESTRICTION = 'role_restriction',
}
